export default "__VITE_ASSET__0f3531ee__"